import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import OggettiUtili from "../../../../../../../utils/OggettiUtili.json";
import styles from "../../../../DatiSpecifici/DatiSpecifici.module.css";
import Input from "../../../../../../../components/textbox/Input";
import Calendar from "../../../../../../../components/calendar/Calendar";
import Utils from "../../../../../../../utils/Utils";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import Autocomplete from "../../../../../../../components/autocomplete/Autocomplete";

class DatiAnagraficiPazienteMorbillo extends Component {


    state = {
        datiPaziente: {
            nomePaziente: "",
            cognomePaziente: "",
            dataDiNascita: "",
            sesso: "",
            codiceFiscale: "",
            nazioneDiNascita: "",
            cittadinanza: "",
            regioneDomicilio: "",
            provinciaDomicilio: "",
            comuneDomicilio: "",
            regioneResidenza: "",
            provinciaResidenza: "",
            comuneResidenza: "",
            arrivoInItalia: "",
            corretto: []
        },
        regioni: OggettiUtili.Regioni,
        province: JSON.parse(sessionStorage.getItem("province")),
        nazioni: JSON.parse(sessionStorage.getItem("nazioni")),
        comuni: Utils.distinctComuni(JSON.parse(sessionStorage.getItem("comuni")), new Date()),
        nazioniPerCodice: JSON.parse(sessionStorage.getItem("nazioniPerCodice")),
        comuniPerCodice: JSON.parse(sessionStorage.getItem("comuniPerCodice")),
        provincePerCodice: JSON.parse(sessionStorage.getItem("provincePerCodice")),

    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this)
        this.createObjectBE = this.createObjectBE.bind(this)
        this.validate = this.validate.bind(this);
    }

    componentDidMount() {

        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiPaziente) {
            let datiPaziente = this.state.datiPaziente
            let datiPazienteCopia = this.props.segnalazioneCopia.schedaSpeciale.datiPaziente
            datiPaziente.nomePaziente = datiPazienteCopia.nomePaziente ? datiPazienteCopia.nomePaziente : ""
            datiPaziente.cognomePaziente = datiPazienteCopia.cognomePaziente ? datiPazienteCopia.cognomePaziente : ""
            datiPaziente.dataDiNascita = datiPazienteCopia.dataDiNascita ? datiPazienteCopia.dataDiNascita : ""
            datiPaziente.sesso = datiPazienteCopia.sesso ? datiPazienteCopia.sesso : ""
            datiPaziente.codiceFiscale = datiPazienteCopia.codiceFiscale ? datiPazienteCopia.codiceFiscale : ""
            datiPaziente.nazioneDiNascita = this.state.nazioniPerCodice[datiPazienteCopia.nazioneDiNascita] ? this.state.nazioniPerCodice[datiPazienteCopia.nazioneDiNascita] : ""
            datiPaziente.cittadinanza = datiPazienteCopia.cittadinanza ? datiPazienteCopia.cittadinanza : ""
            if (datiPazienteCopia.regioneDomicilio && datiPazienteCopia.regioneDomicilio.length === 2) {
                datiPazienteCopia.regioneDomicilio = datiPazienteCopia.regioneDomicilio.concat("0")
            }
            datiPaziente.regioneDomicilio = OggettiUtili.Regioni[datiPazienteCopia.regioneDomicilio] ? OggettiUtili.Regioni[datiPazienteCopia.regioneDomicilio] : ""
            datiPaziente.provinciaDomicilio = this.state.provincePerCodice[datiPazienteCopia.provinciaDomicilio] ? this.state.provincePerCodice[datiPazienteCopia.provinciaDomicilio] : ""
            datiPaziente.comuneDomicilio = this.state.comuniPerCodice[datiPazienteCopia.comuneDomicilio] ? this.state.comuniPerCodice[datiPazienteCopia.comuneDomicilio] : ""
            if (datiPazienteCopia.regioneResidenza && datiPazienteCopia.regioneResidenza.length === 2) {
                datiPazienteCopia.regioneResidenza = datiPazienteCopia.regioneResidenza.concat("0")
            }
            datiPaziente.regioneResidenza = OggettiUtili.Regioni[datiPazienteCopia.regioneResidenza] ? OggettiUtili.Regioni[datiPazienteCopia.regioneResidenza] : ""
            datiPaziente.provinciaResidenza = this.state.provincePerCodice[datiPazienteCopia.provinciaResidenza] ? this.state.provincePerCodice[datiPazienteCopia.provinciaResidenza] : ""
            datiPaziente.comuneResidenza = this.state.comuniPerCodice[datiPazienteCopia.comuneResidenza] ? this.state.comuniPerCodice[datiPazienteCopia.comuneResidenza] : this.state.nazioniPerCodice[datiPazienteCopia.comuneResidenza] ? this.state.nazioniPerCodice[datiPazienteCopia.comuneResidenza] : ""
            datiPaziente.arrivoInItalia = datiPazienteCopia.arrivoInItalia ? datiPazienteCopia.arrivoInItalia : ""
            this.setState({datiPaziente: datiPaziente})
            this.controlloCorrettezza()
            let oggettoBE = this.createObjectBE()
            this.props.createOggettoBeAndcontrolloCorrettezza("datiPaziente", oggettoBE, this.state.datiPaziente.corretto)

        } else if (this.props.datiPaziente) {
            let datiPazienteState = this.state.datiPaziente
            let datiPazienteProps = this.props.datiPaziente
            datiPazienteState.nomePaziente = datiPazienteProps.nomePaziente
            datiPazienteState.cognomePaziente = datiPazienteProps.cognomePaziente
            datiPazienteState.dataDiNascita = datiPazienteProps.dataDiNascita
            datiPazienteState.sesso = datiPazienteProps.sesso
            datiPazienteState.codiceFiscale = datiPazienteProps.codiceFiscale
            datiPazienteState.nazioneDiNascita = datiPazienteProps.cittadinanza
            datiPazienteState.cittadinanza = datiPazienteProps.cittadinanza
            datiPazienteState.comuneDomicilio = datiPazienteProps.comuneDomicilio
            datiPazienteState.provinciaDomicilio = datiPazienteProps.comuneDomicilio.codiceProvincia ? this.state.provincePerCodice[datiPazienteProps.comuneDomicilio.codiceProvincia] : ""
            if (datiPazienteState.provinciaDomicilio.codiceRegione && datiPazienteState.provinciaDomicilio.codiceRegione.length === 2) {
                datiPazienteState.provinciaDomicilio.codiceRegione = datiPazienteState.provinciaDomicilio.codiceRegione.concat("0")
            }
            datiPazienteState.regioneDomicilio = datiPazienteState.provinciaDomicilio.codiceRegione ? this.state.regioni[datiPazienteState.provinciaDomicilio.codiceRegione] : ""
            if (datiPazienteProps.comuneResidenza !== datiPazienteState.comuneDomicilio) {
                datiPazienteState.regioneResidenza = datiPazienteProps.regioneResidenza
                datiPazienteState.provinciaResidenza = datiPazienteProps.provinciaResidenza
                datiPazienteState.comuneResidenza = datiPazienteProps.comuneResidenza.codice ? this.state.comuniPerCodice[datiPazienteProps.comuneResidenza.codice] ? this.state.comuniPerCodice[datiPazienteProps.comuneResidenza.codice] : this.state.nazioniPerCodice[datiPazienteProps.comuneResidenza.codice] ? this.state.nazioniPerCodice[datiPazienteProps.comuneResidenza.codice] : "" : ""
            } else {
                datiPazienteState.regioneResidenza = ""
                datiPazienteState.provinciaResidenza = ""
                datiPazienteState.comuneResidenza = ""
            }

            this.setState({datiPaziente: datiPazienteState})
            this.controlloCorrettezza()
            let oggettoBE = this.createObjectBE()
            this.props.createOggettoBeAndcontrolloCorrettezza("datiPaziente", oggettoBE, this.state.datiPaziente.corretto)

        } else {
            this.controlloCorrettezza()
            let oggettoBE = this.createObjectBE()
            this.props.createOggettoBeAndcontrolloCorrettezza("datiPaziente", oggettoBE, this.state.datiPaziente.corretto)
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState !== this.state) {
            let res = this.createObjectBE()
            this.props.createOggettoBeAndcontrolloCorrettezza("datiPaziente", res, this.state.datiPaziente.corretto, this.validate())
        }
    }

    validate() {

        if (this.state.datiPaziente.dataDiNascita && Utils.validateDate(this.state.datiPaziente.dataDiNascita, "Messages.DataNascita", "Messages.DataNascitaOdierna")) {
            return Utils.validateDate(this.state.datiPaziente.dataDiNascita, "Messages.DataNascita", "Messages.DataNascitaOdierna")
        }
        let date = new Date()
        if (this.state.datiPaziente.arrivoInItalia && this.state.datiPaziente.arrivoInItalia < 1900) {
            return "Messages.DataArrivoItalia"
        }
        if (this.state.datiPaziente.arrivoInItalia && this.state.datiPaziente.arrivoInItalia > date.getFullYear()) {
            return "Messages.DataArrivoItaliaOdierna"
        }
        return ""

    }

    riceviValore(field, event) {
        let datiPaziente = this.state.datiPaziente
        datiPaziente[field] = event.target.value
        if (!datiPaziente.nazioneDiNascita || datiPaziente.nazioneDiNascita.codice === "100") {
            datiPaziente.arrivoInItalia = ""
        }
        if ((datiPaziente.regioneDomicilio && !datiPaziente.regioneDomicilio.codice) || !datiPaziente.regioneDomicilio) {
            datiPaziente.provinciaDomicilio = ""
        }
        if (!datiPaziente.provinciaDomicilio.codice) {
            datiPaziente.comuneDomicilio = ""
        }
        if (!datiPaziente.regioneResidenza.codice) {
            datiPaziente.provinciaResidenza = ""
        }
        if (!datiPaziente.provinciaResidenza.codice && !this.state.nazioniPerCodice[datiPaziente.comuneResidenza.codice]) {
            datiPaziente.comuneResidenza = ""
        }
        if (datiPaziente.regioneResidenza.codice && this.state.nazioniPerCodice[datiPaziente.comuneResidenza.codice]) {
            datiPaziente.comuneResidenza = ""
        }


        this.setState({datiPaziente: datiPaziente})
        this.controlloCorrettezza()
        let oggettoBE = this.createObjectBE()
        let corretto = datiPaziente.corretto
        this.props.createOggettoBeAndcontrolloCorrettezza("datiPaziente", oggettoBE, corretto, this.validate())
    }

    controlloCorrettezza() {
        let datiPaziente = this.state.datiPaziente
        datiPaziente.corretto = []

        if (!datiPaziente.nomePaziente && !this.props.datiPaziente.soggettoAnonimizzato) datiPaziente.corretto[0] = "Campo \"Nome\" mancante";
        if (!datiPaziente.cognomePaziente && !this.props.datiPaziente.soggettoAnonimizzato) datiPaziente.corretto[1] = "Campo \"Cognome\" mancante";
        if (!datiPaziente.dataDiNascita || (datiPaziente.dataDiNascita && Utils.isDateInValid(Utils.transformDateForBackend(datiPaziente.dataDiNascita), "-"))) datiPaziente.corretto[2] = "Campo \"Data di nascita\" mancante o errato";
        if (!datiPaziente.sesso) datiPaziente.corretto[3] = "Campo \"Sesso\" mancante";
        if (datiPaziente.nazioneDiNascita && datiPaziente.nazioneDiNascita.codice !== "100" && !datiPaziente.arrivoInItalia) datiPaziente.corretto[4] = "Campo \"Anno di arrrivo in Italia\" mancante";
        if (datiPaziente.codiceFiscale && !Utils.isCFValid(datiPaziente.codiceFiscale)) datiPaziente.corretto[6] = "Campo \"Codice fiscale\" errato";
        if (this.state.datiPaziente.cittadinanza.codice && this.state.datiPaziente.cittadinanza.codice !== "100" && !this.props.datiPaziente.cfNonNoto && !this.state.datiPaziente.codiceFiscale) datiPaziente.corretto[7] = "Campo \"Codice fiscale\" mancante";

        return this.setState({datiPaziente: datiPaziente})

    }

    createObjectBE() {
        let oggettoBE = JSON.parse(JSON.stringify(this.state.datiPaziente))
        oggettoBE.nazioneDiNascita = oggettoBE.nazioneDiNascita ? oggettoBE.nazioneDiNascita.codice ? oggettoBE.nazioneDiNascita.codice : "" : ""
        oggettoBE.regioneDomicilio = oggettoBE.regioneDomicilio ? oggettoBE.regioneDomicilio.codice ? oggettoBE.regioneDomicilio.codice : "" : ""
        oggettoBE.provinciaDomicilio = oggettoBE.provinciaDomicilio ? oggettoBE.provinciaDomicilio.codice ? oggettoBE.provinciaDomicilio.codice : "" : ""
        oggettoBE.comuneDomicilio = oggettoBE.comuneDomicilio ? oggettoBE.comuneDomicilio.codice ? oggettoBE.comuneDomicilio.codice : "" : ""
        oggettoBE.regioneResidenza = oggettoBE.regioneResidenza ? oggettoBE.regioneResidenza.codice ? oggettoBE.regioneResidenza.codice : "" : ""
        oggettoBE.provinciaResidenza = oggettoBE.provinciaResidenza ? oggettoBE.provinciaResidenza.codice ? oggettoBE.provinciaResidenza.codice : "" : ""
        oggettoBE.comuneResidenza = oggettoBE.comuneResidenza ? oggettoBE.comuneResidenza.codice ? oggettoBE.comuneResidenza.codice : "" : ""
        Utils.removeFieldFromObject(oggettoBE, "corretto")
        let res = Utils.removeEmptyValueFromObject(oggettoBE)
        return res
    }


    render() {

        const {t} = this.props

        const datiAnagraficiPaziente = (
            <div className={"container"} style={{marginTop: "1rem"}}>
                <div className="row">
                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello4' : ''}`}>
                        <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                {t("SchedaSpecialeMorbillo.cognome")}
                                {!this.props.datiPaziente.soggettoAnonimizzato ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}</p>
                            <Input id={"idCognomePaziente"}
                                   onChange={this.riceviValore}
                                   field={"cognomePaziente"}
                                   value={this.state.datiPaziente.cognomePaziente}
                                   placeholder={t("SchedaSpecialeMorbillo.cognome")}/>
                        </div>
                    </div>
                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                        <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                {t("SchedaSpecialeMorbillo.nome")}
                                {!this.props.datiPaziente.soggettoAnonimizzato ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}</p>
                            <Input id={"idNomePaziente"}
                                   onChange={this.riceviValore}
                                   field={"nomePaziente"}
                                   value={this.state.datiPaziente.nomePaziente}
                                   placeholder={t("SchedaSpecialeMorbillo.nome")}/>
                        </div>
                    </div>
                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                        <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                {t("SchedaSpecialeMorbillo.dataDiNascita")}
                                <span className={styles.mandatoryColor}>*</span></p>
                            <Calendar
                                id={"dataDiNascita"} value={this.state.datiPaziente.dataDiNascita}
                                field={"dataDiNascita"}
                                newCalendar={true}
                                onChange={this.riceviValore}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaSpecialeMorbillo.dataDiNascita"))}
                                error={(this.state.datiPaziente.dataDiNascita === "" || this.state.datiPaziente.dataDiNascita == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiPaziente.dataDiNascita), "-")
                                }
                            >
                            </Calendar>
                        </div>
                    </div>
                    <div className={`col-lg-2 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                        <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9", paddingLeft: "10px"}}>
                                {t("SchedaSpecialeMorbillo.sesso")}
                                <span className={styles.mandatoryColor}>*</span>
                            </p>
                            <div className={"row"}>
                                <RadioButton id={"sessoM"} name={"sesso"} label={"M"}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"M"}
                                             checked={this.state.datiPaziente.sesso === "M"}/>
                                <RadioButton id={"sessoF"} name={"sesso"} label={"F"}
                                             onClick={this.setSesso} smallLabel={true}
                                             value={"F"}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             checked={this.state.datiPaziente.sesso === "F"}>
                                </RadioButton>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"row"} style={{marginTop: "1rem"}}>
                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello4' : ''}`}>
                        <div className={styles.fieldContainer}>
                            <p style={{color: "#1b7ea9"}}>
                                {t("SchedaSpecialeMorbillo.codiceFiscale")}
                                {!this.props.datiPaziente.cfNonNoto && this.state.datiPaziente.cittadinanza.codice && this.state.datiPaziente.cittadinanza.codice !== "100" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                            <Input id={"idCodiceFiscale"}
                                   onChange={this.riceviValore}
                                   disabled={(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || !!(this.props.datiPaziente && this.props.datiPaziente.cfNonNoto)}
                                   field={"codiceFiscale"}
                                   onValidate={(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) ? 2 : this.state.datiPaziente.codiceFiscale ? (Utils.isCFValid(this.state.datiPaziente.codiceFiscale) ? 2 : 1) : 0}
                                   errorMessage={"Codice fiscale non valido"}
                                   value={this.state.datiPaziente.codiceFiscale}
                                   placeholder={t("SchedaSpecialeMorbillo.codiceFiscale")}/>
                        </div>
                    </div>

                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                        <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                {t("SchedaSpecialeMorbillo.nazioneDiNascita")}</p>
                            <Autocomplete
                                id={"nazioneDiNascita"}
                                value={this.state.datiPaziente.nazioneDiNascita}
                                keyField={"codice"}
                                descriptionField={"descrizione"}
                                suggestionField={"descrizione"}
                                onChange={this.riceviValore}
                                field={"nazioneDiNascita"}
                                placeholder={t("SchedaSpecialeMorbillo.nazioneDiNascita")}
                                suggestions={this.state.nazioni}
                            >
                            </Autocomplete>
                        </div>
                    </div>
                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}
                         style={{
                             display:
                                 this.state.datiPaziente.nazioneDiNascita ? this.state.datiPaziente.nazioneDiNascita.codice !== "100" ? "" : "none" : ""
                         }}
                    >
                        <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                {t("SchedaSpecialeMorbillo.arrivoInItalia")}
                                {this.state.datiPaziente.nazioneDiNascita && this.state.datiPaziente.nazioneDiNascita.codice !== "100" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                            <Input id={"arrivoInItalia"}
                                   type={"number"}
                                   min={"0"}
                                   onChange={this.riceviValore}
                                   field={"arrivoInItalia"}
                                   value={this.state.datiPaziente.arrivoInItalia}
                                   placeholder={t("SchedaSpecialeMorbillo.arrivoInItalia")}/>
                        </div>
                    </div>
                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                        <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                            <p style={{color: "#1b7ea9"}}>
                                {t("SchedaSpecialeMorbillo.cittadinanza")}</p>
                            <Autocomplete
                                id={"cittadinanza"}
                                value={this.state.datiPaziente.cittadinanza}
                                keyField={"codice"}
                                descriptionField={"descrizione"}
                                suggestionField={"descrizione"}
                                onChange={this.riceviValore}
                                field={"cittadinanza"}
                                placeholder={t("SchedaSpecialeMorbillo.cittadinanza")}
                                suggestions={this.state.nazioni}
                            >
                            </Autocomplete>
                        </div>
                    </div>
                </div>
                <div className={"row"} style={{marginTop: "1rem"}}>
                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                        <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                            <p style={{color: "#1b7ea9"}}>
                                {t("SchedaSpecialeMorbillo.RegioneDomicilio")}</p>
                            <Autocomplete
                                id={"idRegioneDomicilio"}
                                onChange={this.riceviValore}
                                field={"regioneDomicilio"}
                                keyField={"codice"}
                                descriptionField={"descrizione"}
                                suggestionField={"descrizione"}
                                value={this.state.datiPaziente.regioneDomicilio}
                                suggestions={this.state.regioni}
                                placeholder={t("SchedaSpecialeMorbillo.RegioneDomicilio")}
                            >
                            </Autocomplete>
                        </div>
                    </div>
                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                        <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                            <p style={{color: "#1b7ea9"}}>
                                {t("SchedaSpecialeMorbillo.provinciaDomicilio")}
                            </p>
                            <Autocomplete id={"idProvinciaDomicilio"}
                                          value={this.state.datiPaziente.provinciaDomicilio}
                                          keyField={"codice"}
                                          descriptionField={"descrizione"}
                                          suggestionField={"descrizione"}
                                          onChange={this.riceviValore}
                                          field={"provinciaDomicilio"}
                                          placeholder={t("SchedaSpecialeMorbillo.provinciaDomicilio")}
                                          suggestions={this.state.datiPaziente.regioneDomicilio && this.state.datiPaziente.regioneDomicilio.codice ?
                                              Utils.filtroProvinceComuni(this.state.datiPaziente.regioneDomicilio.codice, this.state.province, "codiceRegione") : ""}
                                          disabled={!this.state.datiPaziente.regioneDomicilio || !this.state.datiPaziente.regioneDomicilio.codice}
                            >
                            </Autocomplete>
                        </div>
                    </div>
                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                        <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                            <p style={{color: "#1b7ea9"}}>
                                {t("SchedaSpecialeMorbillo.comuneDomicilio")}</p>
                            <Autocomplete id={"idComuneDomicilio"}
                                          value={this.state.datiPaziente.comuneDomicilio}
                                          keyField={"codice"}
                                          descriptionField={"descrizione"}
                                          suggestionField={"descrizione"}
                                          onChange={this.riceviValore}
                                          field={"comuneDomicilio"}
                                          placeholder={t("SchedaSpecialeMorbillo.comuneDomicilio")}
                                          suggestions={this.state.datiPaziente.provinciaDomicilio.codice ?
                                              Utils.filtroProvinceComuni(this.state.datiPaziente.provinciaDomicilio.codice, this.state.comuni, "codiceProvincia") : ""}
                                          disabled={!this.state.datiPaziente.provinciaDomicilio.codice}
                            >
                            </Autocomplete>
                        </div>
                    </div>
                </div>

                <div className={"row"} style={{marginTop: "1rem"}}>
                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                        <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                            <p style={{color: "#1b7ea9"}}>
                                {t("SchedaSpecialeMorbillo.regioneResidenza")}</p>
                            <Autocomplete
                                id={"idRegioneResidenza"}
                                onChange={this.riceviValore}
                                field={"regioneResidenza"}
                                keyField={"codice"}
                                descriptionField={"descrizione"}
                                suggestionField={"descrizione"}
                                value={this.state.datiPaziente.regioneResidenza}
                                suggestions={this.state.regioni}
                                placeholder={t("SchedaSpecialeMorbillo.regioneResidenza")}
                            >
                            </Autocomplete>
                        </div>
                    </div>
                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                        <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                            <p style={{color: "#1b7ea9"}}>
                                {t("SchedaSpecialeMorbillo.provinciaResidenza")}
                            </p>
                            <Autocomplete id={"idProvinciaResidenza"}
                                          value={this.state.datiPaziente.provinciaResidenza}
                                          keyField={"codice"}
                                          descriptionField={"descrizione"}
                                          suggestionField={"descrizione"}
                                          onChange={this.riceviValore}
                                          field={"provinciaResidenza"}
                                          placeholder={t("SchedaSpecialeMorbillo.provinciaResidenza")}
                                          suggestions={this.state.datiPaziente.regioneResidenza.codice ?
                                              Utils.filtroProvinceComuni(this.state.datiPaziente.regioneResidenza.codice, this.state.province, "codiceRegione") : ""}
                                          disabled={!this.state.datiPaziente.regioneResidenza.codice}
                            >
                            </Autocomplete>
                        </div>
                    </div>
                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                        <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                {t("SchedaSpecialeMorbillo.comuneResidenza")}</p>
                            <Autocomplete id={"idComuneResidenza"}
                                          value={this.state.datiPaziente.comuneResidenza}
                                          keyField={"codice"}
                                          descriptionField={"descrizione"}
                                          suggestionField={"descrizione"}
                                          onChange={this.riceviValore}
                                          field={"comuneResidenza"}
                                          placeholder={t("SchedaSpecialeMorbillo.comuneResidenza")}
                                          suggestions={this.state.datiPaziente.provinciaResidenza ?
                                              Utils.filtroProvinceComuni(this.state.datiPaziente.provinciaResidenza.codice, this.state.comuni, "codiceProvincia") :
                                              this.state.nazioniPerCodice}
                            >
                            </Autocomplete>
                        </div>
                    </div>
                </div>

            </div>
        )
        return (
            <div>
                <h6>{t("SchedaSpecialeMorbillo.DatiAnagraficiPaziente")}</h6>
                <hr className={styles.hr}/>
                {datiAnagraficiPaziente}
            </div>
        );
    }

}

export default withTranslation('common')(DatiAnagraficiPazienteMorbillo)
